<template>
    <v-container fluid class="pt-0">
        <v-row no-gutters>
            <v-col cols="12" class="pl-0 mb-0 pb-0">
                <v-tabs
                    class="planejamento-tabs"
                    active-class="activeMyClass"
                    background-color="transparent"
                    v-model="tabIndex"
                >
                    <v-tab>Cadastro de Ondas</v-tab>
                    <v-tab v-if="podeGerenciarPermissoes">Permissões</v-tab>
                </v-tabs>
            </v-col>
        </v-row>

        <v-card v-if="tabIndex === 0" class="cabecalho-ondas px-5 py-3 brt-15 w-100 mt-0" elevation="0">
            <v-row>
                <v-col class="flex-grow-1">
                    <v-toolbar-title class="page-title cabecalho-ondas__titulo">
                        Cadastro de Ondas
                    </v-toolbar-title>
                </v-col>
                <v-col class="d-flex justify-center">
                    <div class="cabecalho-ondas__placeholder" aria-hidden="true"></div>
                </v-col>
                <div class="d-flex py-3 px-4">
                    <v-btn class="new-button" color="primary" @click="exportar">
                        <v-icon left>mdi-microsoft-excel</v-icon>
                        Exportar
                    </v-btn>
                    <v-btn class="ml-5 new-button" color="primary" @click="abrirImportacao">
                        <v-icon left>mdi-upload</v-icon>
                        Importar
                    </v-btn>
                </div>
            </v-row>
        </v-card>

        <v-card v-if="tabIndex === 0" class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
            <v-data-table
                class="elevation-0 tabela"
                :headers="headers"
                :items="dados"
                :items-per-page="12"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                item-key="chave_local"
                multi-sort
            >
                <template v-slot:[`item.data_disparo_input`]="{ item }">
                    <v-text-field
                        v-model="item.data_disparo_input"
                        type="date"
                        dense
                        outlined
                        hide-details
                        class="input-cinza"
                    ></v-text-field>
                </template>

                <template v-slot:[`item.mes_referencia_input`]="{ item }">
                    <v-select
                        v-model="item.mes_referencia_input"
                        :items="mesesReferencia"
                        item-text="text"
                        item-value="value"
                        dense
                        outlined
                        hide-details
                        class="input-cinza"
                    ></v-select>
                </template>

                <template v-slot:[`item.ano`]="{ item }">
                    <v-text-field
                        v-model="item.ano"
                        type="number"
                        dense
                        outlined
                        hide-details
                        class="input-cinza"
                        min="1900"
                        max="2999"
                    ></v-text-field>
                </template>

                <template v-slot:[`item.acoes`]="{ item }">
                    <v-btn
                        icon
                        color="error"
                        :disabled="item.id_cadastro_onda"
                        @click="removerLinha(item)"
                        title="Remover linha nova"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <div class="table-footer-prepend d-flex justify-space-between mt-3">
                <v-btn color="primary" class="new-button" @click="adicionarLinha">
                    <v-icon left>mdi-plus-thick</v-icon>
                    Adicionar linha
                </v-btn>

                <v-btn color="primary" class="new-button" :loading="salvandoTabela" @click="salvarTabelaOndas">
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar tabela
                </v-btn>
            </div>
        </v-card>

        <v-card
            v-if="tabIndex === 1 && podeGerenciarPermissoes"
            class="px-5 py-5 br-15 w-100 mt-0"
            elevation="0"
        >
            <v-row no-gutters class="mb-4">
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="buscaPermissoes"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">
                    <v-btn color="primary" class="pr-4" @click="salvarPermissoesOndas">
                        <v-icon left>mdi-content-save</v-icon>
                        Salvar Permissões
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :headers="headersPermissoes"
                :items="usuariosPermissoes"
                :items-per-page="10"
                :search="buscaPermissoes"
                :footer-props="tableConfig"
                :options.sync="paginationPermissoes"
                class="elevation-0"
                show-select
                item-key="id_usuario"
                v-model="permissoesSelecionadas"
                multi-sort
            ></v-data-table>
        </v-card>

        <v-dialog content-class="br-15" v-model="dialogoImportacao" width="600">
            <v-card>
                <v-toolbar elevation="0" dark class="primary-degrade white--text fix-flex">
                    <v-toolbar-title>Importação de Cadastro de Ondas.</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="fecharImportacao"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-5 pb-0">
                    <div v-if="avisosImportacao.length > 0" class="instrucoes importacao-ondas__instrucoes">
                        <h4 color="primary">Para realizar a importação de cadastro de ondas, siga as instruções abaixo.</h4>
                        <ul>
                            <li v-for="(aviso, index) in avisosImportacao" :key="`aviso-${index}`">
                                {{ aviso }}
                            </li>
                        </ul>
                    </div>

                    <v-file-input
                        v-model="arquivo"
                        label="Arquivo"
                        class="input-cinza mt-5"
                        outlined
                        dense
                        accept=".csv,.xlsx,.xls"
                        prepend-icon="mdi-paperclip"
                        hide-details="auto"
                    ></v-file-input>

                    <v-alert
                        v-if="errosImportacao.length > 0"
                        type="error"
                        outlined
                        dense
                        class="mt-4"
                    >
                        A importação retornou {{ errosImportacao.length }} erro(s).
                    </v-alert>

                    <v-data-table
                        v-if="errosImportacao.length > 0"
                        class="elevation-0 mt-2"
                        :headers="headersErrosImportacao"
                        :items="errosImportacao"
                        :items-per-page="5"
                        :footer-props="{ 'items-per-page-options': [5, 10, 20] }"
                    ></v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="new-button px-6 mb-3 mr-2"
                        color="primary"
                        :disabled="!arquivo"
                        @click="importar"
                    >
                        <v-icon left>mdi-upload</v-icon>
                        Importar Arquivo
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
export default {
    name: 'cadastro_ondas',
    // Menu alvo para destinatarios de Cadastro de Ondas.
    // O fluxo novo exige que a permissao seja salva no menu 112.
    MENU_ID_PERMISSAO_DESTINATARIOS: 112,
    data() {
        return {
            tabIndex: 0,
            carregando: false,
            buscaPermissoes: '',
            dialogoImportacao: false,
            arquivo: null,
            avisosImportacao: [],
            errosImportacao: [],
            dados: [],
            salvandoTabela: false,
            usuariosPermissoes: [],
            permissoesSelecionadas: [],
            paginationPermissoes: {},
            podeGerenciarPermissoes: false,
            menuIdCadastroOndas: null,
            menuIdDestinatariosOndas: 112,
            tableConfig: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },
            headersPermissoes: [
                { text: 'Cargo', value: 'cargo', align: 'center' },
                { text: 'Nome', value: 'nome', align: 'center' },
                { text: 'Login', value: 'login', align: 'center' },
                { text: 'ID Usuário', value: 'id_usuario', align: 'center' },
            ],
            headers: [
                {
                    text: 'Data Disparo',
                    value: 'data_disparo_input',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Mês Referência',
                    value: 'mes_referencia_input',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Ano',
                    value: 'ano',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Ações',
                    value: 'acoes',
                    class: 'th-separador min-width-100',
                    align: 'center',
                    sortable: false,
                },
            ],
            headersErrosImportacao: [
                { text: 'Linha', value: 'linha', align: 'center' },
                { text: 'Campo', value: 'campo', align: 'center' },
                { text: 'Mensagem', value: 'mensagem', align: 'left' },
            ],
            mesesReferencia: [
                { text: 'Janeiro', value: 1 },
                { text: 'Fevereiro', value: 2 },
                { text: 'Marco', value: 3 },
                { text: 'Abril', value: 4 },
                { text: 'Maio', value: 5 },
                { text: 'Junho', value: 6 },
                { text: 'Julho', value: 7 },
                { text: 'Agosto', value: 8 },
                { text: 'Setembro', value: 9 },
                { text: 'Outubro', value: 10 },
                { text: 'Novembro', value: 11 },
                { text: 'Dezembro', value: 12 },
            ],
        }
    },
    async created() {
        await this.carregarConfiguracoesPermissao()

        if (this.$route.name === 'cadastroOndasPermissoes' && this.podeGerenciarPermissoes) {
            this.tabIndex = 1
        }

        if (this.tabIndex === 0) {
            await this.filtrar()
        }

        if (this.tabIndex === 1 && this.podeGerenciarPermissoes) {
            await this.filtrarPermissoesOndas()
        }
    },
    watch: {
        async tabIndex(valor) {
            if (valor === 0 && this.dados.length === 0) {
                await this.filtrar()
            }

            if (valor === 1 && this.podeGerenciarPermissoes && this.usuariosPermissoes.length === 0) {
                await this.filtrarPermissoesOndas()
            }
        },
    },
    methods: {
        async carregarConfiguracoesPermissao() {
            try {
                const [menuResponse, usuarioMenuResponse] = await Promise.all([
                    this.$http().post('/usuario/menu', {}),
                    this.$http().post('/usuario/usuarioMenu', {}),
                ])

                const menu = menuResponse.data || []
                const menuUsuario = usuarioMenuResponse.data || []

                const menuCadastroOndas = menu.find((item) => item.caminho === 'cadastroOndas')

                this.menuIdCadastroOndas = menuCadastroOndas ? menuCadastroOndas.id_menu : null

                if (this.$options.MENU_ID_PERMISSAO_DESTINATARIOS) {
                    this.menuIdDestinatariosOndas = this.$options.MENU_ID_PERMISSAO_DESTINATARIOS
                }

                this.podeGerenciarPermissoes = menuUsuario.some(
                    (item) => item.caminho === 'cadastroOndasPermissoes'
                )
            } catch (error) {
                console.error('Erro ao carregar configuração de permissões de Cadastro de Ondas:', error)
                this.podeGerenciarPermissoes = false
            }
        },
        async filtrarPermissoesOndas() {
            if (!this.menuIdDestinatariosOndas) {
                this.$dialog.notify.warning('Menu 112 de destinatários não encontrado para configurar permissões.')
                return
            }

            this.carregando = true
            try {
                const data = { id_menu: this.menuIdDestinatariosOndas }
                const response = await this.$http().post('/usuario/permissaoMenu', { data })

                this.usuariosPermissoes = response.data || []
                this.permissoesSelecionadas = this.usuariosPermissoes.filter((item) => item.permissao)
            } catch (error) {
                console.error('Erro ao carregar permissões de Cadastro de Ondas:', error)
                this.$dialog.notify.error('Erro ao carregar permissões de Cadastro de Ondas!')
                this.usuariosPermissoes = []
                this.permissoesSelecionadas = []
            } finally {
                this.carregando = false
            }
        },
        async salvarPermissoesOndas() {
            if (!this.menuIdDestinatariosOndas) {
                this.$dialog.notify.warning('Menu 112 de destinatários não encontrado para salvar permissões.')
                return
            }

            this.carregando = true
            try {
                const data = {
                    menus: [this.menuIdDestinatariosOndas],
                    usuarios: this.usuariosPermissoes.map((usuario) => ({
                        id_usuario: usuario.id_usuario,
                        permissao: this.permissoesSelecionadas.includes(usuario),
                    })),
                }

                const response = await this.$http().post('/usuario/salvarUsuarioMenu', { data })

                if (response.data?.sucesso === false) {
                    this.$dialog.notify.error(response.data.msg || 'Erro ao salvar permissões de Cadastro de Ondas!')
                    return
                }

                this.$dialog.notify.success('Permissões de Cadastro de Ondas salvas com sucesso!')
                await this.filtrarPermissoesOndas()
            } catch (error) {
                console.error('Erro ao salvar permissões de Cadastro de Ondas:', error)
                this.$dialog.notify.error('Erro ao salvar permissões de Cadastro de Ondas!')
            } finally {
                this.carregando = false
            }
        },
        formatarData(valor) {
            if (!valor) return ''

            if (typeof valor === 'string') {
                if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
                    return valor
                }

                if (/^\d{4}-\d{2}-\d{2}/.test(valor)) {
                    const [ano, mes, dia] = valor.split('T')[0].split('-')
                    return `${dia}/${mes}/${ano}`
                }
            }

            const data = new Date(valor)
            if (!Number.isNaN(data.getTime())) {
                const dia = String(data.getDate()).padStart(2, '0')
                const mes = String(data.getMonth() + 1).padStart(2, '0')
                const ano = data.getFullYear()
                return `${dia}/${mes}/${ano}`
            }

            return String(valor)
        },
        formatarParaInputDate(valor) {
            if (!valor) return ''

            if (typeof valor === 'string') {
                if (/^\d{4}-\d{2}-\d{2}/.test(valor)) {
                    return valor.split('T')[0]
                }

                if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
                    const [dia, mes, ano] = valor.split('/')
                    return `${ano}-${mes}-${dia}`
                }
            }

            const data = new Date(valor)
            if (!Number.isNaN(data.getTime())) {
                const dia = String(data.getDate()).padStart(2, '0')
                const mes = String(data.getMonth() + 1).padStart(2, '0')
                const ano = data.getFullYear()
                return `${ano}-${mes}-${dia}`
            }

            return ''
        },
        extrairMesReferencia(valor) {
            if (valor === null || valor === undefined || valor === '') {
                return 1
            }

            if (typeof valor === 'number') {
                return valor >= 1 && valor <= 12 ? valor : 1
            }

            if (typeof valor === 'string') {
                const valorTrim = valor.trim()

                if (/^\d+$/.test(valorTrim)) {
                    const mesNumero = Number(valorTrim)
                    return mesNumero >= 1 && mesNumero <= 12 ? mesNumero : 1
                }

                if (/^\d{4}-\d{2}-\d{2}/.test(valorTrim)) {
                    const partes = valorTrim.split('T')[0].split('-')
                    const mesNumero = Number(partes[1])
                    return mesNumero >= 1 && mesNumero <= 12 ? mesNumero : 1
                }

                if (/^\d{2}\/\d{2}\/\d{4}$/.test(valorTrim)) {
                    const partes = valorTrim.split('/')
                    const mesNumero = Number(partes[1])
                    return mesNumero >= 1 && mesNumero <= 12 ? mesNumero : 1
                }

                const mapaMeses = {
                    janeiro: 1,
                    fevereiro: 2,
                    marco: 3,
                    abril: 4,
                    maio: 5,
                    junho: 6,
                    julho: 7,
                    agosto: 8,
                    setembro: 9,
                    outubro: 10,
                    novembro: 11,
                    dezembro: 12,
                }

                const normalizado = valorTrim
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()

                return mapaMeses[normalizado] || 1
            }

            return 1
        },
        montarMesReferenciaData(ano, mes) {
            const anoNumero = Number(ano)
            const mesNumero = Number(mes)

            if (!Number.isInteger(anoNumero) || anoNumero < 1900 || anoNumero > 2999) {
                return null
            }

            if (!Number.isInteger(mesNumero) || mesNumero < 1 || mesNumero > 12) {
                return null
            }

            return `${anoNumero}-${String(mesNumero).padStart(2, '0')}-01`
        },
        normalizarAvisosImportacao(response) {
            const bruto =
                response?.data?.avisos ||
                response?.data?.data?.avisos ||
                response?.data?.padrao?.avisos ||
                response?.data?.mensagens ||
                response?.data?.data?.mensagens ||
                response?.data?.avisosImportacao ||
                []

            if (Array.isArray(bruto)) {
                return bruto.filter((item) => !!item).map((item) => String(item))
            }

            if (typeof bruto === 'string') {
                return [bruto]
            }

            if (bruto && typeof bruto === 'object') {
                return Object.values(bruto)
                    .filter((item) => !!item)
                    .map((item) => String(item))
            }

            return []
        },
        criarLinhaVazia() {
            const anoBase = this.obterAnoBase()
            const mesReferenciaPadrao = 1

            return {
                id_cadastro_onda: null,
                data_disparo_input: '',
                mes_referencia_input: mesReferenciaPadrao,
                ano: String(anoBase),
                chave_local: `novo-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
            }
        },
        obterAnoBase() {
            const primeiroAno = this.dados.find((item) => item.ano)?.ano
            const anoNumero = Number(primeiroAno)
            return Number.isInteger(anoNumero) && anoNumero > 1900
                ? anoNumero
                : new Date().getFullYear()
        },
        montarLinha(item = {}) {
            return {
                ...item,
                data_disparo_formatada: this.formatarData(item.data_disparo),
                data_disparo_input: this.formatarParaInputDate(item.data_disparo),
                mes_referencia_input: this.extrairMesReferencia(item.mes_referencia),
                ano: item.ano ? String(item.ano) : String(this.obterAnoBase()),
                chave_local:
                    item.id_cadastro_onda ||
                    item.id_onda ||
                    `existente-${Math.random().toString(36).slice(2, 8)}`,
            }
        },
        gerarLinhasPadraoAno(anoBase) {
            const linhas = []

            for (let mes = 1; mes <= 12; mes += 1) {
                const mesFormatado = String(mes).padStart(2, '0')

                linhas.push({
                    id_cadastro_onda: null,
                    data_disparo_input: '',
                    mes_referencia_input: Number(mesFormatado),
                    ano: String(anoBase),
                    chave_local: `padrao-${anoBase}-${mesFormatado}-${Math.random()
                        .toString(36)
                        .slice(2, 8)}`,
                })
            }

            return linhas
        },
        adicionarLinha() {
            this.dados.unshift(this.criarLinhaVazia())
        },
        removerLinha(item) {
            const index = this.dados.findIndex((linha) => linha.chave_local === item.chave_local)
            if (index >= 0) {
                this.dados.splice(index, 1)
            }
        },
        validarTabela() {
            const erros = []

            this.dados.forEach((item, index) => {
                const linha = index + 1

                if (!item.mes_referencia_input) {
                    erros.push(`Linha ${linha}: Mês Referência é obrigatório.`)
                }

                if (!item.ano || !/^\d{4}$/.test(String(item.ano))) {
                    erros.push(`Linha ${linha}: Ano deve ter 4 dígitos.`)
                }
            })

            if (erros.length > 0) {
                this.$dialog.notify.warning(erros.slice(0, 3).join(' '))
                return false
            }

            return true
        },
        async salvarTabelaOndas() {
            if (!this.validarTabela()) {
                return
            }

            this.salvandoTabela = true

            try {
                const linhas = this.dados.map((item) => ({
                    id_cadastro_onda: item.id_cadastro_onda || null,
                    data_disparo: item.data_disparo_input || null,
                    mes_referencia: Number(item.mes_referencia_input),
                    mes_referencia_data: this.montarMesReferenciaData(item.ano, item.mes_referencia_input),
                    ano: Number(item.ano),
                }))

                let response = null

                try {
                    response = await this.$http().post('/administrativo/cadastro-ondas/salvar', {
                        data: linhas,
                    })
                } catch (erroPrimeiraTentativa) {
                    response = await this.$http().post('/administrativo/cadastro-ondas/salvar', {
                        linhas,
                    })
                }

                if (response.status === 200 && response.data?.sucesso !== false) {
                    this.$dialog.notify.success(response.data?.mensagem || 'Tabela de Cadastro de Ondas salva com sucesso!')
                    await this.filtrar()
                    return
                }

                this.$dialog.notify.error(response.data?.msg || response.data?.mensagem || 'Erro ao salvar tabela de Cadastro de Ondas!')
            } catch (error) {
                console.error('Erro ao salvar tabela de cadastro de ondas:', error)
                this.$dialog.notify.error(
                    error.response?.data?.msg ||
                        error.response?.data?.mensagem ||
                        'Erro ao salvar tabela de Cadastro de Ondas!'
                )
            } finally {
                this.salvandoTabela = false
            }
        },
        async filtrar() {
            this.carregando = true
            try {
                const response = await this.$http().post('/administrativo/cadastro-ondas/lista', {})
                const lista = response.data?.data || []
                const linhasApi = lista.map((item) => this.montarLinha(item))
                const anoBase = Number(lista[0]?.ano) || new Date().getFullYear()

                if (linhasApi.length === 0) {
                    this.dados = this.gerarLinhasPadraoAno(anoBase)
                } else if (linhasApi.length < 12) {
                    const faltantes = 12 - linhasApi.length
                    const linhasPadrao = this.gerarLinhasPadraoAno(anoBase).slice(0, faltantes)
                    this.dados = [...linhasApi, ...linhasPadrao]
                } else {
                    this.dados = linhasApi
                }
            } catch (error) {
                console.error('Erro ao carregar cadastro de ondas:', error)
                this.$dialog.notify.error('Erro ao carregar Cadastro de Ondas!')
                this.dados = []
            } finally {
                this.carregando = false
            }
        },
        async exportar() {
            try {
                const response = await this.$http().post('/administrativo/cadastro-ondas/exportar', {})
                const urlArquivo =
                    response?.data?.url ||
                    response?.data?.data?.url ||
                    response?.data?.arquivo ||
                    response?.data?.data?.arquivo

                if (response.status === 200 && urlArquivo) {
                    const urlFinal = /^https?:\/\//.test(urlArquivo)
                        ? urlArquivo
                        : `${this.$http('baseURL')}${urlArquivo}`

                    window.open(urlFinal, '_blank')
                    this.$dialog.notify.success('Cadastro de Ondas exportado com sucesso!')
                    return
                }

                const responseBlob = await this.$http().post(
                    '/administrativo/cadastro-ondas/exportar',
                    {},
                    { responseType: 'blob' }
                )

                if (responseBlob?.status === 200 && responseBlob?.data) {
                    const blob = new Blob([responseBlob.data])
                    const urlBlob = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = urlBlob
                    link.setAttribute('download', `cadastro-ondas-${Date.now()}.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(urlBlob)
                    this.$dialog.notify.success('Cadastro de Ondas exportado com sucesso!')
                    return
                }

                this.$dialog.notify.error(response.data?.mensagem || 'Erro ao exportar Cadastro de Ondas!')
            } catch (error) {
                console.error('Erro na exportação de cadastro de ondas:', error)
                this.$dialog.notify.error('Erro de conexão ao exportar Cadastro de Ondas!')
            }
        },
        abrirImportacao() {
            this.dialogoImportacao = true
            this.errosImportacao = []
            this.carregarPadraoImportacao()
        },
        fecharImportacao() {
            this.dialogoImportacao = false
            this.arquivo = null
            this.errosImportacao = []
        },
        async carregarPadraoImportacao() {
            try {
                let response = null

                try {
                    response = await this.$http().get('/administrativo/cadastro-ondas/padrao-importacao')
                } catch (errorGet) {
                    response = await this.$http().post('/administrativo/cadastro-ondas/padrao-importacao', {})
                }

                this.avisosImportacao = this.normalizarAvisosImportacao(response)
            } catch (error) {
                this.avisosImportacao = [
                    'A base utilizada para importação deve ser parecida com a base exportada.',
                    'As colunas Data Disparo, Mês Referência e Ano são obrigatórias e os nomes devem ser idênticos aos da base exportada.',
                    'Formato de data esperado nas colunas de data: DD/MM/AAAA.',
                    'Mês Referência deve ser preenchido de Janeiro a Dezembro.',
                ]
            }
        },
        normalizarErrosImportacao(erros = []) {
            if (!Array.isArray(erros)) {
                return []
            }

            return erros.map((erro, index) => ({
                linha: erro?.linha || erro?.row || erro?.numero_linha || '-',
                campo: erro?.campo || erro?.coluna || '-',
                mensagem:
                    erro?.mensagem ||
                    erro?.msg ||
                    erro?.erro ||
                    (typeof erro === 'string' ? erro : `Erro ${index + 1}`),
            }))
        },
        async importar() {
            if (!this.arquivo) {
                this.$dialog.notify.warning('Selecione um arquivo para importar.')
                return
            }

            this.carregando = true
            try {
                const formData = new FormData()
                formData.append('arquivo', this.arquivo)
                formData.append('files', this.arquivo)

                const response = await this.$http().post('/administrativo/cadastro-ondas/importar', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })

                if (response.status === 200) {
                    const erros = response.data?.erros || response.data?.data?.erros || []
                    this.errosImportacao = this.normalizarErrosImportacao(erros)

                    this.$dialog.notify.success(response.data?.mensagem || 'Cadastro de Ondas importado com sucesso!')

                    if (this.errosImportacao.length === 0) {
                        this.fecharImportacao()
                    }

                    await this.filtrar()
                } else {
                    this.$dialog.notify.error(response.data?.mensagem || 'Erro ao importar Cadastro de Ondas!')
                }
            } catch (error) {
                console.error('Erro na importação de cadastro de ondas:', error)
                const erros = error.response?.data?.erros || error.response?.data?.data?.erros || []
                this.errosImportacao = this.normalizarErrosImportacao(erros)
                const mensagemErro = error.response?.data?.mensagem || error.response?.data?.msg || 'Erro ao importar Cadastro de Ondas!'
                this.$dialog.notify.error(mensagemErro)
            } finally {
                this.carregando = false
            }
        },
    },
}
</script>

<style>

.importacao-ondas__instrucoes {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 16px;
    color: #6f6f6f;
}

.importacao-ondas__instrucoes h4 {
    color: #1e9387;
    margin-bottom: 8px;
}

.importacao-ondas__instrucoes ul {
    margin-bottom: 0;
}

.planejamento-tabs .activeMyClass:hover:before {
    background: none;
}

.planejamento-tabs .v-tab:before {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}

.planejamento-tabs .v-tabs-slider {
    width: 70%;
    margin: 0 15%;
}

.planejamento-tabs {
    margin-left: -0px;
}

.planejamento-tabs .v-tab {
    min-width: 120px;
    font-size: 1.2rem;
    font-weight: normal !important;
    letter-spacing: 0px;
    color: #999 !important;
    text-transform: none !important;
}

.planejamento-tabs .activeMyClass {
    background: #fff;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    color: #000 !important;
}
</style>
